import React from "react";
import { Modal, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const CustomModal = ({
  title = "Modal Title",
  visible,
  handleOk,
  handleCancel,
  footer = true,
  cancelBtnText = "Cancel",
  okBtnText = "Confirm",
  children,
  width = 600,
  className,
}) => {
  return (
    <Modal
      title={<span className="font-color">{title}</span>}
      open={visible}
      onCancel={handleCancel}
      className={className}
      centered
      width={width}
      closeIcon={<CloseOutlined className="font-color" />}
      footer={
        footer && (
          <div className="logout-modal-footer">
            <Button key="cancel" onClick={handleCancel}>
              {cancelBtnText}
            </Button>

            <Button
              key="logout"
              type="primary"
              htmlType="submit"
              onClick={handleOk}
            >
              {okBtnText}
            </Button>
          </div>
        )
      }
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
